export default __webpack_public_path__ + "static/luxe-logo-2-e88023bce991a41ef91bcdab92b000c9.png";